import React from 'react';
import { TextField, Box } from '@mui/material';
import 'mathlive';

/**
 * TableCell Component
 * A reusable cell component that supports MathLive input for math expressions
 * or regular text input for text content.
 */
const TableCell = ({
  value = '',
  onChange,
  type = 'math',        // 'math' or 'text'
  disabled = false,
  readOnly = false,
  placeholder = '',
  size = 'small',       // 'small' | 'medium'
  sx = {},
}) => {

  // Read-only math display
  if (type === 'math' && readOnly) {
    return (
      <Box
        sx={{
          display: 'inline-block',
          minWidth: size === 'small' ? '60px' : '80px',
          minHeight: size === 'small' ? '32px' : '40px',
          padding: '4px 8px',
          ...sx,
        }}
      >
        <math-field
          read-only
          value={value || ''}
          style={{
            display: 'inline-block',
            verticalAlign: 'middle',
            border: 'none',
            background: 'transparent',
            fontSize: size === 'small' ? '14px' : '16px',
            color: 'inherit',
          }}
        />
      </Box>
    );
  }

  // Editable math input
  if (type === 'math') {
    return (
      <Box sx={{ ...sx }}>
        <math-field
          value={value || ''}
          onInput={(evt) => {
            if (onChange && !disabled && !readOnly) {
              onChange(evt.target.value);
            }
          }}
          style={{
            width: '100%',
            minWidth: size === 'small' ? '60px' : '80px',
            minHeight: size === 'small' ? '32px' : '40px',
            fontSize: size === 'small' ? '14px' : '16px',
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '4px 8px',
            backgroundColor: '#fff',
          }}
        />
      </Box>
    );
  }

  // Text input (read-only or editable)
  return (
    <TextField
      value={value}
      onChange={(evt) => {
        if (onChange && !disabled && !readOnly) {
          onChange(evt.target.value);
        }
      }}
      disabled={disabled}
      placeholder={placeholder}
      size={size}
      variant={readOnly ? 'standard' : 'outlined'}
      InputProps={{
        readOnly: readOnly,
        disableUnderline: readOnly,
      }}
      sx={{
        minWidth: size === 'small' ? '60px' : '80px',
        '& .MuiInputBase-input': {
          padding: size === 'small' ? '6px 8px' : '10px 12px',
        },
        ...sx,
      }}
    />
  );
};

export default TableCell;
